<template>
  <StyledDiv margin="30px 0">
    <StyledDiv
      v-if="thanksBarDisplayed || errorBarDisplayed"
      position="relative"
      top="0"
      left="0"
      :backgroundColor="determineColor"
      height="150px"
    >
      <StyledText>{{ determineText }}</StyledText>
    </StyledDiv>
    <StyledText padding="20px 0">Send us a Message</StyledText>
    <StyledDiv
      width="80%"
      flexWrap="wrap"
      flexDirection="row"
      justifyContent="space-between"
    >
      <input
        class="firstName"
        v-model="firstName"
        label="First name"
        placeholder="First name"
      />
      <input
        class="lastName"
        size="100"
        v-model="lastName"
        label="Last name"
        placeholder="Last name"
      />
      <input
        class="email"
        v-model="email"
        label="Email"
        placeholder="me@myEmail.com"
      />
      <textarea
        class="message"
        v-model="message"
        label="Type Message Below"
        placeholder="Hello.."
      />
      <StyledDiv flexDirection="row" justifyContent="space-around">
        <StyledDiv
          height="50px"
          margin="10px 0"
          width="45%"
          :backgroundColor="styled('pdfPink')"
          borderRadius="5px"
          @click="toggleCancel"
          cursor="pointer"
          hoverBrightness="brightness(90%)"
        >
          <StyledText :fontSize="styled('fontSize-medium')">Cancel</StyledText>
        </StyledDiv>
        <StyledDiv
          height="50px"
          margin="10px 0"
          width="45%"
          :backgroundColor="styled('lightBlue')"
          borderRadius="5px"
          @click="toggleSubmit"
          cursor="pointer"
          hoverBrightness="brightness(90%)"
        >
          <StyledText :fontSize="styled('fontSize-medium')">Submit</StyledText>
        </StyledDiv>
      </StyledDiv>
    </StyledDiv>
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
export default {
  components: {
    StyledDiv,
    StyledText
  },
  props: ["cancelFunc", "submitFunc"],
  data() {
    return {
      email: "",
      firstName: "",
      lastName: "",
      message: "",
      thanksBarDisplayed: false,
      errorBarDisplayed: false
    };
  },
  computed: {
    determineText() {
      this.setCancelTimer();
      if (this.thanksBarDisplayed) {
        return "Thank You, we'll get back to you soon!";
      } else {
        return "Error with the message, try again";
      }
    },
    determineColor() {
      if (this.thanksBarDisplayed) {
        return this.styled("brightGreen");
      } else {
        return this.styled("brightRed");
      }
    }
  },
  methods: {
    setCancelTimer() {
      setTimeout(() => {
        this.cancelFunc();
      }, 3000);
    },
    toggleCancel() {
      this.cancelFunc();
    },
    toggleSubmit() {
      if (
        this.email !== "" &&
        this.lastName !== "" &&
        this.firstName !== "" &&
        this.message !== ""
      ) {
        event.preventDefault();
        window.emailjs
          .send("default_service", "contactus", {
            from_name: this.firstName + " " + this.lastName,
            message_html: this.message,
            reply_to: this.email
          })
          .then(
            () => {
              this.thanksBarDisplayed = true;
            },
            () => {
              this.errorBarDisplayed = true;
            }
          );
      } else {
        alert("Please complete all fields");
      }
    },
    handleEmail(e) {
      const { value } = e.target;
      this.email = value;
    },
    handleMessage(e) {
      const { value } = e.target;
      this.message = value;
    },
    handleFirstName(e) {
      const { value } = e.target;
      this.firstName = value;
    },
    handleLastName(e) {
      const { value } = e.target;
      this.lastName = value;
    },
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
.firstName {
  width: 45%;
  height: 50px;
  font-size: 22px;
  margin: 10px 0;
  color: black;
}
.lastName {
  width: 45%;
  height: 50px;
  margin: 10px 0;
  font-size: 22px;
  color: black;
}
.email {
  width: 100%;
  height: 50px;
  margin: 10px 0;
  font-size: 22px;
  color: black;
}
.message {
  width: 100%;
  height: 150px;
  margin: 10px 0;
  font-size: 22px;
  color: black;
}
</style>
